import { up } from 'styled-breakpoints';
import styled, { css } from 'styled-components';
import { Tooltip } from 'src/components/general/display/tooltip';
import { Icon, IconProps } from 'src/components/general/icon';
import { preventDefaultAndStopPropagation } from 'src/components/general/inputs/helpers';
import { FlexRow } from 'src/components/layout/flex-row';
import { useBreakpoint } from 'src/hooks/use-breakpoint';
import { useVisible } from 'src/hooks/use-visible';

export type BasePluginProps = {
  disabled?: boolean;
};

export const PluginTriggerIcon = styled(Icon)<{ $disabled?: boolean }>`
  display: flex;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;

    path {
      fill: ${({ theme }) => theme.colors.flint};
    }
  }

  ${({ $disabled }) => {
    if ($disabled) {
      return css`
        cursor: not-allowed !important;
        opacity: 0.5;
      `;
    }

    return css`
      &.active,
      &:hover {
        svg path {
          fill: ${({ theme }) => theme.colors.smalt};
        }
      }
    `;
  }}
`;

export const PluginIcon = ({
  tooltip,
  isOpen = true,
  disabled = false,
  ...rest
}: IconProps & { tooltip?: string; isOpen?: boolean; disabled?: boolean }) => {
  const tooltipVisibilityHandler = useVisible();
  const breakpointUpMd = useBreakpoint(up('md'));

  const handleShowTooltip = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    preventDefaultAndStopPropagation(e);

    tooltipVisibilityHandler.show();
  };

  const handleHideTooltip = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    preventDefaultAndStopPropagation(e);

    tooltipVisibilityHandler.close();
  };

  return (
    <Tooltip
      title={tooltip}
      trigger={['hover']}
      visible={
        breakpointUpMd && tooltip && !isOpen && !disabled
          ? tooltipVisibilityHandler.visible
          : false
      }
    >
      <FlexRow
        onMouseEnter={handleShowTooltip}
        onMouseLeave={handleHideTooltip}
        onBlur={tooltipVisibilityHandler.close}
      >
        <PluginTriggerIcon {...rest} $disabled={disabled} />
      </FlexRow>
    </Tooltip>
  );
};
